/**
 * Class represents a factory pattern.
 */
export default class StratisFactory {
    /**
     * Create instances.
     * @param {string} selector - elements selector to search.
     * @param {object} options  - plugin options.
     * @param {constructor} ClassConstructor - class constructor for object creation.
     */
    static create(selector, options, ClassConstructor) {
        if (typeof selector === 'string') {
            const instances = [...document.querySelectorAll(selector)];

            if (!instances.length) {
                return undefined;
            }

            return instances.map(element => new ClassConstructor(element, options));
        }
    }
}
